"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.PopOverPrompt = void 0;
var _react = _interopRequireWildcard(require("react"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _Icon = require("../../Elements/Icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}
function setStorage(method, name, value) {
  switch (method) {
    case 'session':
      window.sessionStorage.setItem(name, value);
      break;
    case 'cookie':
      _jsCookie.default.set(name, value);
      break;
    default:
      window.sessionStorage.setItem(name, value);
  }
}
function getStorageMethod(method, name) {
  let myStorage;
  switch (method) {
    case 'session':
      myStorage = window.sessionStorage.getItem(name);
      break;
    case 'cookie':
      myStorage = _jsCookie.default.get(name);
      break;
    default:
      myStorage = window.sessionStorage.getItem(name);
  }
  return myStorage;
}
function performCheck(name, method, value, check) {
  const storedValue = getStorageMethod(method, name);

  // there is no storage match for this name and method, so show the popover
  if (!storedValue) return false;
  // there is a storage match, it does exist, so dont show the popover
  if (storedValue && check === 'exists') {
    return true;
  }
  // there is a storage match, it does exist and we will show it if the new value is great
  if (storedValue && check === 'latest') {
    const compare = !(value > storedValue);
    return compare;
  }
  return false;
}
const PopOverPrompt = props => {
  const {
    htmlText,
    icon,
    arrowPosition,
    storage
  } = props;
  const {
    name,
    method,
    value,
    check
  } = storage;
  const [hasDisplayed, setHasDisplayed] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    // use Storage for this popover
    const useStorage = !isEmpty(storage);
    if (useStorage) {
      const status = performCheck(name, method, value, check);
      setStorage(method, name, value);
      setHasDisplayed(status);
    }
  }, []);
  if (!hasDisplayed) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "ccl-e-pop-over-prompt",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: `ccl-e-pop-over-prompt__flex ccl-e-pop-over-prompt__flex--${arrowPosition}`,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          type: icon,
          color: "inverse",
          size: "md"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "ccl-e-pop-over-prompt__inner ccl__text  ccl__text--inverse ccl__text--x-small-body-text"
          // eslint-disable-next-line react/no-danger
          ,
          dangerouslySetInnerHTML: {
            __html: _dompurify.default.sanitize(htmlText)
          }
        })]
      })
    });
  }
  return null;
};
exports.PopOverPrompt = PopOverPrompt;
PopOverPrompt.defaultProps = {
  icon: 'fingerpoint',
  htmlText: '',
  arrowPosition: 'bottom-center',
  storage: {}
};